(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('agenzia', {
            parent: 'entity',
            url: '/agenzia?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.agenzia.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/agenzia/agenzias.html',
                    controller: 'AgenziaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('agenzia');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('agenzia-detail', {
            parent: 'entity',
            url: '/agenzia/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.agenzia.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/agenzia/agenzia-detail.html',
                    controller: 'AgenziaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('agenzia');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Agenzia', function($stateParams, Agenzia) {
                    return Agenzia.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'agenzia',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('agenzia-detail.edit', {
            parent: 'agenzia-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/agenzia/agenzia-dialog.html',
                    controller: 'AgenziaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Agenzia', function(Agenzia) {
                            return Agenzia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('agenzia.new', {
            parent: 'agenzia',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/agenzia/agenzia-dialog.html',
                    controller: 'AgenziaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                provincia: null,
                                comune: null,
                                cap: null,
                                indirizzo: null,
                                tel: null,
                                email: null,
                                partitaIva: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('agenzia', null, { reload: 'agenzia' });
                }, function() {
                    $state.go('agenzia');
                });
            }]
        })
        .state('agenzia.edit', {
            parent: 'agenzia',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/agenzia/agenzia-dialog.html',
                    controller: 'AgenziaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Agenzia', function(Agenzia) {
                            return Agenzia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('agenzia', null, { reload: 'agenzia' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('agenzia.delete', {
            parent: 'agenzia',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/agenzia/agenzia-delete-dialog.html',
                    controller: 'AgenziaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Agenzia', function(Agenzia) {
                            return Agenzia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('agenzia', null, { reload: 'agenzia' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
